import { render, staticRenderFns } from "./OrderLabel.vue?vue&type=template&id=329daf04&scoped=true"
import script from "./OrderLabel.vue?vue&type=script&lang=js"
export * from "./OrderLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329daf04",
  null
  
)

export default component.exports